/* eslint-disable camelcase */
import ApiFiles from '../api_files';

export const getDownloadFollowups = async (
  file_extension: string,
  document_type: string,
  followup_ids: Array<number>,
  per_page: number,
  favorite: boolean = false,
) => {
  const response = await ApiFiles.get(
    `/followups/search.${file_extension}?favorite=${favorite}&${
      file_extension === 'docx' ? 'docx=true' : ''
    }${
      file_extension === 'xlsx' ? 'xlsx=true' : ''
    }&per_page=${per_page}&followups_ids=${followup_ids.join(',')}`,
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${document_type}_${Date.now()}.${file_extension}`);
  document.body.appendChild(link);
  link.click();
};
